import { createSlice } from '@reduxjs/toolkit'

import { ActionPayload } from '../index.d'
import { loadLivedata, LivedataPayload } from './livedata.actions'

export interface LivedataState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  data: LivedataPayload | null
  error: null | string
}

const initialState: LivedataState = {
  status: 'idle',
  data: null,
  error: null,
}

export const livedataReducer = createSlice({
  name: 'livedata',
  initialState,
  reducers: {},
  extraReducers: {
    [loadLivedata.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadLivedata.fulfilled.toString()]: (state, action: ActionPayload<LivedataPayload>) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadLivedata.rejected.toString()]: (state, action: ActionPayload<string>) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer
